module.exports = __webpack_public_path__ + "img/satori komeiji.6a7fbba1.png";